import axios from 'axios';

/**
 * Initialize axios interceptors
 */
export const initializeInterceptors = () => {
  // Response interceptor
  axios.interceptors.response.use(
    (response) => {
      // Check if the response contains indexer data
      if (response.data &&
          (response.config.url?.includes('/api/indexer-state') ||
           response.config.url?.includes('/api/indexer-state-metrics') ||
           response.config.url?.includes('/api/indexer-state-health'))) {

        // Remove tooltips object from the response
        const responseData = response.data as any;
        if (responseData.tooltips) {
          delete responseData.tooltips;
        }

        // Check if there's an indexer object with tooltips
        if (responseData.indexer) {
          const indexer = responseData.indexer as any;
          if (indexer.tooltips) {
            delete indexer.tooltips;
          }
        }

        // Check if there are indexers array with tooltips
        if (responseData.indexers && Array.isArray(responseData.indexers)) {
          responseData.indexers.forEach((indexer: any) => {
            if (indexer.tooltips) {
              delete indexer.tooltips;
            }
          });
        }

        // Check if there are metrics with tooltips
        if (responseData.metrics) {
          const metrics = responseData.metrics as any;
          if (metrics.tooltips) {
            delete metrics.tooltips;
          }
        }

        // Check for nested objects that might contain tooltips
        const removeTooltipsRecursively = (obj: any) => {
          if (!obj || typeof obj !== 'object') return;

          if (obj.tooltips) {
            delete obj.tooltips;
          }

          Object.keys(obj).forEach(key => {
            if (obj[key] && typeof obj[key] === 'object') {
              removeTooltipsRecursively(obj[key]);
            }
          });
        };

        removeTooltipsRecursively(response.data);
      }

      return response;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
};
